module.exports = __webpack_public_path__ + "img/briefing-3.388efed1.jpg";